import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BiscuitIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M8.008 1.92c0-.516-.33-.989-.837-.912C5.194 1.307 1 2.575 1 7.957 1 11.847 4.138 15 8.008 15c3.702 0 6.734-2.885 6.99-6.54a.476.476 0 0 0-.482-.503 2.51 2.51 0 0 1-2.503-2.515c0-.325-.278-.605-.597-.548a2.4 2.4 0 0 1-.404.045A3.01 3.01 0 0 1 8.008 1.92M5 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.75 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 7.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.75 11.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
			clipRule="evenodd"
		></path>
	</svg>
))
